<template>
  <div class="row pl-3 pr-3 mb-2">
    <i
      class="fas fa-user-circle text-orange ml-2 mr-2"
      style="font-size: 32px !important; margin-top: 2rem !important;"
    />
    <div class="col col-sm col-12 mt-md-4 pb-2">
      <div class="color-black font-14 font-weight-bold">
        Estudiante:
      </div>
      <div
        class="regular word-break color-gray"
        v-text="`${item.name} - ${item.studentSieId}` || '-'"
      />
    </div>
    <div class="col col-sm col-12 mt-md-4 pb-2">
      <div class="color-black font-14 font-weight-bold">
        Edad:
      </div>
      <div class="regular word-break color-gray" v-text="item.age || '-'" />
    </div>
    <slot name="actions" />
  </div>
</template>

<script>
export default {
  name: 'StudentItem',
  props: {
    item: { type: Object, default: null },
  },
};
</script>

<style scoped lang="scss">
@import '~@/assets/scss/variables/colors.scss';
</style>
